import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {Thuisverzorger, ThuisverzorgerDto} from './thuisverzorger';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {Page, PageDto} from '../core/pagination/page';
import {PageRequest} from '../core/pagination/page-request';

@Injectable({
  providedIn: 'root'
})
export class ThuisverzorgerService {
  private http = inject(HttpClient);

  getThuisverzorgerMe$(): Observable<Thuisverzorger> {
    return this.http
      .get<ThuisverzorgerDto>(`${environment.apiUrl}/thuisverzorgers/me`)
      .pipe(map(dto => Thuisverzorger.deserialize(dto)));
  }

  getThuisverzorgersPage$(pageRequest: PageRequest<Thuisverzorger>): Observable<Page<Thuisverzorger>> {
    return this.http
      .post<PageDto<ThuisverzorgerDto>>(`${environment.apiUrl}/thuisverzorgers/page`, pageRequest)
      .pipe(map(pageDto => new Page(
        pageDto.ascending,
        pageDto.pageSize,
        pageDto.pageNumber,
        pageDto.lastPage,
        pageDto.items.map(dto => Thuisverzorger.deserialize(dto)),
      )));
  }

  getThuisverzorgersByIds$(thuisverzorgerIds: Array<{ id: string, nummer: string }>): Observable<Array<Thuisverzorger>> {
    return this.http
      .post<Array<ThuisverzorgerDto>>(`${environment.apiUrl}/thuisverzorgers/ids`, {ids: thuisverzorgerIds.map(id => id.id)})
      .pipe(map(thuisverzorgerDtos => this.getThuisverzorgers(thuisverzorgerIds, thuisverzorgerDtos)));
  }

  private getThuisverzorgers(thuisverzorgerIds: Array<{ id: string, nummer: string }>, thuisverzorgerDtos: Array<ThuisverzorgerDto>): Array<Thuisverzorger> {
    const thuisverzorgers = thuisverzorgerDtos.map(dto => Thuisverzorger.deserialize(dto));
    return thuisverzorgerIds
      .map(thuisverzorgerId =>
        thuisverzorgers.find(thuisverzorger => thuisverzorger.hasId(thuisverzorgerId.id))
        || Thuisverzorger.verwijderd(thuisverzorgerId.id, thuisverzorgerId.nummer)
      );
  }

  postThuisverzorger$(thuisverzorger: Thuisverzorger): Observable<Thuisverzorger> {
    return this.http
      .post<ThuisverzorgerDto>(`${environment.apiUrl}/thuisverzorgers`, thuisverzorger.toDto())
      .pipe(map(dto => Thuisverzorger.deserialize(dto)));
  }

  getThuisverzorgerById$(id: string): Observable<Thuisverzorger> {
    return this.http.get<ThuisverzorgerDto>(`${environment.apiUrl}/thuisverzorgers/${id}`)
      .pipe(map(dto => Thuisverzorger.deserialize(dto)));
  }

  updateThuisverzorger$(thuisverzorger: Thuisverzorger): Observable<Thuisverzorger> {
    return this.http.put<ThuisverzorgerDto>(`${environment.apiUrl}/thuisverzorgers/${thuisverzorger.getId()}`, thuisverzorger.toDto())
      .pipe(map(dto => Thuisverzorger.deserialize(dto)));
  }

  deleteThuisverzorger$(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/thuisverzorgers/${id}`);
  }
}
